export type BoundingBox = {
  east: number;
  north: number;
  south: number;
  west: number;
};

export const isInsideBoundingBox = (
  latitude: number,
  longitude: number,
  bbox: BoundingBox,
) =>
  latitude >= bbox.south &&
  latitude <= bbox.north &&
  longitude >= bbox.west &&
  longitude <= bbox.east;
